/* ==========================================================================
   Whole House Filter Finder
   --------------------------------------------------------------------------
   Renders a four-step chooser wherever the page contains

       <div id="mwf-filter-finder"></div>

   Also accepts [data-mwf-filter-finder] if you would rather use an attribute,
   and mounts into every match, so the same article can carry more than one.

   The routing rules are ordered and the first match wins, so the most specific
   combinations sit highest. Every product handle below is a real, active
   product. When one is retired, update PRODUCTS here - the rest of the file
   refers to products by key, never by handle.
   ========================================================================== */
(function () {
  'use strict';

  var SHOP  = 'https://mywaterfilter.com.au';
  var CDN = 'https://cdn.shopify.com/s/files/1/0455/8071/4143/';
  var P = function (h) { return SHOP + '/products/' + h; };
  var C = function (h) { return SHOP + '/collections/' + h; };

  /* ------------------------------------------------------------- icons --- */
  var I = {
    tap:  '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M6 13h9v5H6z"/><path d="M15 15h6a3 3 0 0 0 3-3V8"/><path d="M21 5h6"/><path d="M10.5 18v3"/><path d="M10.5 24.5c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5c0-1.6-2.5-4-2.5-4s-2.5 2.4-2.5 4Z"/></svg>',
    tank: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M7 11h18v15a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2z"/><path d="M5 11l11-7 11 7"/><path d="M11 17h10"/><path d="M11 22h10"/></svg>',
    bore: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M16 3v18"/><path d="M11 21h10l-2 8h-6z"/><path d="M6 10c3 0 3 3 6 3"/><path d="M26 10c-3 0-3 3-6 3"/></svg>',
    home1:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 14 16 5l11 9"/><path d="M8 13v13h16V13"/><path d="M14 26v-7h4v7"/></svg>',
    home2:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 14 12 6l9 8"/><path d="M6 13v13h12V13"/><path d="M21 26h8V12l-5-4-3 2.7"/><path d="M11 26v-6h3v6"/></svg>',
    home3:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 27h26"/><path d="M5 27V12l7-5 7 5v15"/><path d="M19 27V14l7 4v9"/><path d="M9 15h2M9 20h2M14 15h2M14 20h2M22 20h2"/></svg>',
    gauge:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 23a12 12 0 1 1 22 0"/><path d="m16 17 6-5"/><circle cx="16" cy="19" r="2"/></svg>',
    drip: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M16 4s-7 8.5-7 13a7 7 0 0 0 14 0c0-4.5-7-13-7-13Z"/></svg>',
    check:'<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m3 8.5 3.2 3.2L13 5"/></svg>',
    tick: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="10" r="8"/><path d="m6.5 10.2 2.3 2.3L13.5 8"/></svg>',
    warn: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 2.8 18.2 17H1.8z"/><path d="M10 8v4"/><path d="M10 14.6h.01"/></svg>',
    help:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="16" cy="16" r="12"/><path d="M12.5 12.5a3.6 3.6 0 0 1 6.9 1.2c0 2.4-3.4 3-3.4 5"/><path d="M16 23h.01"/></svg>',
    pin:'<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M16 29s10-8.1 10-15a10 10 0 0 0-20 0c0 6.9 10 15 10 15z"/><circle cx="16" cy="14" r="3.6"/></svg>'
  };

  /* --------------------------------------------------------- questions --- */
  var SOURCES = [
    { id: 'city', icon: I.tap,  t: 'Town or city mains',   d: 'Council supplied, treated with chlorine or chloramine' },
    { id: 'tank', icon: I.tank, t: 'Rain water tank',      d: 'Roof catchment, no disinfectant added' },
    { id: 'bore', icon: I.bore, t: 'Bore, river or creek', d: 'Groundwater or surface water on your property' },
    { id: 'both', icon: I.tank, t: 'Both mains and a tank', d: 'Town water to the house, a tank as well' },
    { id: 'unsure', icon: I.help, t: "I'm not sure", d: 'Show me how to tell which one I have' }
  ];

  /* Where the customer is. It does not change the recommendation - it is asked
     last for that reason - but it tells us which state to route an install or
     a plumber referral to, and it is the one thing we cannot infer later. */
  var STATES = [
    { id: 'NSW', icon: I.pin, t: 'New South Wales', d: 'Includes the ACT' },
    { id: 'VIC', icon: I.pin, t: 'Victoria',        d: '' },
    { id: 'QLD', icon: I.pin, t: 'Queensland',      d: '' },
    { id: 'WA',  icon: I.pin, t: 'Western Australia', d: '' },
    { id: 'SA',  icon: I.pin, t: 'South Australia', d: '' },
    { id: 'TAS', icon: I.pin, t: 'Tasmania',        d: '' },
    { id: 'NT',  icon: I.pin, t: 'Northern Territory', d: '' },
    { id: 'skip', icon: I.help, t: 'Rather not say', d: 'It will not change your result' }
  ];

  /* A house on both mains and a tank is treated as a tank throughout: tank
     water is the harder case, and equipment rated for it handles mains too.
     Everything that branches on source reads this rather than state.source,
     so 'both' needs no duplicated concern list, rules or collections. */
  function srcKey(s) { return s.source === 'both' ? 'tank' : s.source; }

  var SIZES = [
    { id: 'sm', icon: I.home1, t: '1–2 people', d: '1 bathroom · 10" housings are usually enough' },
    { id: 'md', icon: I.home2, t: '3–4 people', d: '2 bathrooms · the most common Australian home' },
    { id: 'lg', icon: I.home3, t: '5 or more',       d: '3+ bathrooms, or you notice pressure drop' }
  ];

  /* Step 3 branches on the water source: a tank owner is never asked about
     chloramine, and a mains owner is never asked about tannins. */
  /* Step 3 branches on the water source: a tank owner is never asked about
     chloramine, a mains customer is never asked about tannins.

     The label is the symptom and the description is the diagnosis, in that
     order. It used to be the other way round, which asked the customer to
     name a contaminant before we would help them - answerable only by someone
     who already knew the answer. Everyone can say the shower smells like a
     pool. The technical term still sits underneath, because on a purchase
     this size people want to learn it.

     'nothing' is a real answer, not a cop-out: plenty of whole house buyers
     have no specific complaint and want general cover. No rule reads it, so
     it falls through to the well-rounded default for that source. */
  var CONCERNS = {
    city: [
      { id: 'chlorine',   t: 'Pool smell from the tap or shower', d: 'Chlorine — the most common complaint on mains water' },
      { id: 'chloramine', t: 'A chemical smell that never fades', d: 'Chloramine — used across most of Sydney, Melbourne and SEQ' },
      { id: 'hard',       t: 'White residue on glass, dry skin and hair', d: 'Hard water and scale' },
      { id: 'sediment',   t: 'Grit in the aerators, cloudy water', d: 'Sediment — common after mains work nearby' },
      { id: 'pfas',       t: 'Worried about forever chemicals', d: 'PFAS — reported in a number of Australian supplies' },
      { id: 'metals',     t: 'Old pipes, worried what is leaching in', d: 'Heavy metals — copper or lead-soldered plumbing' },
      { id: 'nothing',    t: 'Nothing specific, I just want better water', d: 'We will suggest a well-rounded system' }
    ],
    tank: [
      { id: 'bacteria',   t: 'Worried about what is on the roof', d: 'Bacteria and parasites — nothing disinfects a tank' },
      { id: 'sediment',   t: 'Visible particles, blocked shower roses', d: 'Sediment and leaf matter' },
      { id: 'tannins',    t: 'Water the colour of weak tea', d: 'Tannins from leaf litter in the tank' },
      { id: 'taste',      t: 'Musty or earthy taste', d: 'Most noticeable late in summer' },
      { id: 'lowph',      t: 'Blue-green staining around fittings', d: 'Low pH slowly corroding your copper' },
      { id: 'metals',     t: 'Roof flashing or old paint above the tank', d: 'Heavy metals washing off the catchment' },
      { id: 'nothing',    t: 'Nothing specific, I just want better water', d: 'We will suggest a well-rounded system' }
    ],
    bore: [
      { id: 'bacteria',   t: 'It comes straight out of the ground untreated', d: 'Bacteria and parasites' },
      { id: 'iron',       t: 'Orange marks on basins and washing', d: 'Iron staining' },
      { id: 'hard',       t: 'White scale, and soap will not lather', d: 'Hard water — very common in Australian groundwater' },
      { id: 'sediment',   t: 'Sand and grit coming through', d: 'Sediment from the bore itself' },
      { id: 'taste',      t: 'Rotten-egg or sulphur smell', d: 'Bad taste and odour' },
      { id: 'metals',     t: 'Worried what is naturally in the ground here', d: 'Heavy metals — arsenic and manganese occur naturally' },
      { id: 'nothing',    t: 'Nothing specific, I just want better water', d: 'We will suggest a well-rounded system' }
    ]
  };

  var PRESSURE = [
    { id: 'pump', icon: I.gauge, t: 'Pumped or mains pressure',  d: 'A pressure pump feeds the house' },
    { id: 'grav', icon: I.drip,  t: 'Gravity fed, low pressure', d: 'Tank sits above the house, no pump' }
  ];

  var DRINKING = [
    { id: 'yes', icon: I.drip, t: 'Yes — add a drinking tap', d: 'Undersink filter or reverse osmosis at the kitchen sink' },
    { id: 'no',  icon: I.tap,  t: 'Whole house only',              d: 'I’ll sort drinking water separately' }
  ];

  /* ---------------------------------------------------------- products --- */
  var PRODUCTS = {
    triplePfas: { h: 'mwf-20x4-5-triple-whole-house-pfas-chlorine-chloramine-removal',
                  n: 'MWF 20" x 4.5" Triple Whole House System with PFAS & Chlorine removal',
                  img: CDN + 'files/MWF_20_x_4.5_Triple_Big_Blue_Whole_House_Water_Filtration_System_with_PFAS_Chlorine_Chloramine_Removal_with_Watermark_480x480.webp?v=1765178754' },
    triple:     { h: 'mwf-20x4-5-triple-whole-house-water-filter',
                  n: 'MWF 20" x 4.5" Triple Whole House Water Filter',
                  img: CDN + 'files/MWF_Whole_House_with_Cartridges_White_Bracket_1_480x480.png?v=1756703280' },
    twin20:     { h: 'mwf-20x4-5-twin-whole-house-filter-stainless',
                  n: 'MWF 20" x 4.5" Twin Whole House Filter — stainless bracket',
                  img: CDN + 'files/mwf-20-4-5-twin-big-blue-whole-house-stainless-steel-bracket_480x480.jpg?v=1777520808' },
    twin10:     { h: 'mwf-10x4-5-twin-whole-house-choice',
                  n: 'MWF 10" x 4.5" Twin Whole House Filter — stainless bracket',
                  img: CDN + 'products/mwf-10-4.5-twin-big-blue-water-filter-system_480x480.jpg?v=1738549533' },
    hard:       { h: 'ultrapure-hard-water-system', n: 'ULTRAPURE Hard Water System',
                  img: CDN + 'files/ULTRAPURE_Home_Filtration_System_with_Super_Seal_Cartridges_Diamond_Magnet_and_Limetron_Mineral_Treatment_Covered__WM_ef012a12-a929-438b-958f-defcf4a97806_480x480.webp?v=1773626539' },
    upHome:     { h: 'ultrapure-home-filtration-system-super-seal-undersink',
                  n: 'ULTRAPURE Home Filtration System with Super Seal Cartridges & Undersink',
                  img: CDN + 'files/ultrapure-home-filtration-system-ultrapure-undersink-twin-ro-system-wm-housing_6ec3625a-9e7a-4801-a118-b48a107ae63c_480x480.webp?v=1777520846' },
    upUlt:      { h: 'ultrapure-ultimate-home-filtration-system-super-seal-ro',
                  n: 'ULTRAPURE ULTIMATE Home Filtration System with Undersink RO',
                  img: CDN + 'files/Ultrapure_Home_Filtration_System_with_Ultrapure_Undersink_Twin_RO_System_Diamond_Magnet_Limetron_Mineral_Treatment_Covered__WM_cefcb90b-e0e0-435e-bd82-96d0d9ecd279_480x480.webp?v=1777521064' },
    tankUv:     { h: 'mwf-20x4-5-twin-whole-house-rain-tank-filter-ultraviolet',
                  n: 'MWF 20" x 4.5" Twin Rain Water Tank Filter with Ultraviolet',
                  img: CDN + 'products/twin_wh_with_uv_magnet_main_with_uvg_label_1_edited_1_ab5e4372-4e88-4651-972a-8c484eb4850a_480x480.jpg?v=1733111658' },
    tankUvLow:  { h: 'mwf-20x4-5-twin-whole-house-low-pressure-rain-tank-filter-ultraviolet',
                  n: 'MWF 20" x 4.5" Twin LOW PRESSURE Rain Tank Filter with Ultraviolet',
                  img: CDN + 'products/twin-wh-with-uv-magnet-main-with-uvg-2_480x480.jpg?v=1739421150' },
    tankPlain:  { h: 'mwf-20x4-5-twin-whole-house-rain-tank-filter',
                  n: 'MWF 20" x 4.5" Twin Whole House Rain Water Tank Filter System',
                  img: CDN + 'products/twin_17_1_480x480.jpg?v=1732694131' },
    ph:         { h: 'mwf-whole-house-ph-elevation-system',
                  n: 'MWF Whole House pH Elevation System with Calcite & Gravel',
                  img: CDN + 'products/gt1-18_media_vessel_hpf_brand_480x480.jpg?v=1732694484' },
    uv40:       { h: 'uv-guard-slt40', n: 'UV Guard SLT40 40W Whole House Ultraviolet System',
                  img: CDN + 'products/slt40_with_40044_480x480.jpg?v=1737098703' }
  };

  var COLLECTIONS = {
    city: { h: 'whole-house-filter-system-for-town-city-water', n: 'Whole house systems for town water' },
    tank: { h: 'whole-house-filter-system-for-rain-water',      n: 'Whole house systems for rain water' },
    bore: { h: 'bore',                                          n: 'Bore water filters' }
  };

  /* Ordered - first match wins. */
  var RULES = [
    { src: 'city', when: function (s) { return s.drink === 'yes' && (s.size === 'lg' || s.concerns.pfas); },
      pick: PRODUCTS.upUlt,
      why: 'You want treated water through the house and properly polished water at the kitchen tap.',
      reasons: ['Whole house filtration plus undersink reverse osmosis in one system',
                'Reverse osmosis is the reliable way to take PFAS out of drinking water',
                'Super Seal cartridges sized for a busy household'] },

    { src: 'city', when: function (s) { return s.drink === 'yes'; },
      pick: PRODUCTS.upHome,
      why: 'Whole house treatment with a dedicated drinking tap, without stepping up to reverse osmosis.',
      reasons: ['Treats every outlet in the house',
                'Adds a separate filtered drinking tap at the kitchen sink',
                'Super Seal cartridges — no gaps around the seal'] },

    { src: 'city', when: function (s) { return s.concerns.hard; },
      pick: PRODUCTS.hard,
      why: 'Scale is the problem to solve first — it damages fixtures and appliances faster than anything else on your list.',
      reasons: ['Built for hard water rather than adapted to it',
                'Protects hot water systems and shower fittings',
                'Pair with a carbon stage for chlorine taste'] },

    { src: 'city', when: function (s) { return s.concerns.pfas || s.concerns.chloramine; },
      pick: PRODUCTS.triplePfas,
      why: 'Chloramine and PFAS both need a longer contact time than a single carbon stage gives you.',
      reasons: ['Three stages: sediment, then two treatment stages',
                'Specified for PFAS, chlorine and chloramine',
                '20" x 4.5" housings keep pressure up across the house'] },

    { src: 'city', when: function (s) { return s.size === 'sm'; },
      pick: PRODUCTS.twin10,
      why: 'For one or two people a 10" twin keeps flow comfortable and cartridges affordable.',
      reasons: ['Sediment plus carbon in two stages',
                'Smaller cartridges cost less to replace',
                'Stainless bracket, choose your own cartridges'] },

    { src: 'city', when: function () { return true; },
      pick: PRODUCTS.triple,
      why: 'The standard three-stage setup for a family home on town water.',
      reasons: ['Sediment, carbon and a third stage of your choosing',
                '20" x 4.5" housings hold pressure across two bathrooms',
                'The most common configuration we ship'] },

    { src: 'tank', when: function (s) { return s.concerns.bacteria && s.pressure === 'grav'; },
      pick: PRODUCTS.tankUvLow,
      why: 'Gravity-fed tanks need a UV unit rated to work at low pressure — a standard unit will underperform.',
      reasons: ['Ultraviolet sized for low pressure systems',
                'Sediment pre-filtration so the UV lamp can actually reach the water',
                'Built for tanks without a pressure pump'] },

    { src: 'tank', when: function (s) { return s.concerns.bacteria; },
      pick: PRODUCTS.tankUv,
      why: 'There is no disinfectant in a rain water tank, so bacteria control means ultraviolet.',
      reasons: ['Ultraviolet disinfection after two filtration stages',
                'Sediment stage protects the UV lamp from shadowing',
                'The standard tank water setup in Australia'] },

    { src: 'tank', when: function (s) { return s.concerns.lowph; },
      pick: PRODUCTS.ph,
      why: 'Rain water is naturally acidic and will keep eating your copper until the pH is lifted.',
      reasons: ['Calcite and gravel raise pH as water passes through',
                'Stops blue-green staining and pinhole leaks',
                'Fit before the rest of your filtration'] },

    { src: 'tank', when: function (s) { return s.size === 'sm'; },
      pick: PRODUCTS.twin10,
      why: 'A 10" twin suits a smaller household on tank water.',
      reasons: ['Sediment and carbon stages',
                'Lower ongoing cartridge cost',
                'Add ultraviolet later if you need it'] },

    { src: 'tank', when: function () { return true; },
      pick: PRODUCTS.tankPlain,
      why: 'Two stages of filtration sized for tank water and a family home.',
      reasons: ['Sediment stage for leaf litter and grit',
                'Carbon stage for taste and odour',
                'Ultraviolet can be added to this system later'] },

    { src: 'bore', when: function (s) { return s.concerns.bacteria; },
      pick: PRODUCTS.uv40,
      why: 'Untreated groundwater needs disinfection, and UV is the practical answer at household scale.',
      reasons: ['46 litres per minute — enough for a family home',
                'Fits after your sediment and carbon stages',
                'No chemicals added to the water'] },

    { src: 'bore', when: function (s) { return s.concerns.hard || s.concerns.iron; },
      pick: PRODUCTS.hard,
      why: 'Hardness and iron are the two things that will wreck fittings on bore water.',
      reasons: ['Targets scale-forming minerals',
                'Reduces orange staining on basins and washing',
                'Get a water test first so the system is sized correctly'] },

    { src: 'bore', when: function () { return true; },
      pick: PRODUCTS.triple,
      why: 'Three stages give you room to configure for whatever the water test comes back with.',
      reasons: ['Sediment, carbon and a third stage you choose',
                'Reconfigure cartridges once you have test results',
                '20" x 4.5" housings for household flow'] }
  ];

  /* A pool per source rather than a fixed pair, because the recommendation is
     drawn from the same catalogue: on the mains + drinking-tap route the old
     fixed list offered ULTRAPURE Home Filtration as a "step up" from itself.
     pickAlts filters the recommendation out and takes the first two that
     remain, so an alternate is always a genuinely different system. */
  var ALT_POOL = {
    city: [{ k: 'Step up',        p: PRODUCTS.upUlt,  d: 'Adds undersink reverse osmosis for drinking water' },
           { k: 'Step up',        p: PRODUCTS.upHome, d: 'Adds a filtered drinking tap at the kitchen sink' },
           { k: 'Also consider',  p: PRODUCTS.triple, d: 'Three stages, configure the cartridges yourself' },
           { k: 'Step down',      p: PRODUCTS.twin10, d: 'Two stages, smaller housings, lower running cost' }],
    tank: [{ k: 'Step up',        p: PRODUCTS.tankUv, d: 'Adds ultraviolet disinfection for bacteria' },
           { k: 'Also consider',  p: PRODUCTS.ph,     d: 'If your copper fittings are staining blue-green' },
           { k: 'Also consider',  p: PRODUCTS.tankPlain, d: 'Two stages without ultraviolet' },
           { k: 'Step down',      p: PRODUCTS.twin10, d: 'Smaller housings, lower running cost' }],
    bore: [{ k: 'Step up',        p: PRODUCTS.upUlt,  d: 'Whole house plus reverse osmosis for drinking' },
           { k: 'Also consider',  p: PRODUCTS.triple, d: 'Three stages, configure once you have test results' },
           { k: 'Also consider',  p: PRODUCTS.twin20, d: 'Two stages if your test comes back clean' }]
  };

  function pickAlts(source, chosenHandle) {
    var out = [];
    var pool = ALT_POOL[source] || [];
    for (var i = 0; i < pool.length && out.length < 2; i++) {
      if (pool[i].p.h !== chosenHandle) out.push(pool[i]);
    }
    return out;
  }

  var STEPS = ['Water source', 'Home size', 'Your water', 'Setup', 'Your state'];

  function resolve(state) {
    for (var i = 0; i < RULES.length; i++) {
      if (RULES[i].src === srcKey(state) && RULES[i].when(state)) return RULES[i];
    }
    return null;
  }

  /* Analytics, when GA4 is present. Never throws if it is not. */
  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) {}
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ----------------------------------------------------------- renderer -- */
  function render(mount, state) {
    mount.innerHTML = '';
    var root = document.createElement('div');
    root.className = 'mwf-ff';

    root.insertAdjacentHTML('beforeend',
      '<div class="mwf-ff__head">' +
        '<div class="mwf-ff__head-t">Which whole house system suits your home?</div>' +
        '<div class="mwf-ff__head-r">' +
          '<div class="mwf-ff__head-s">Five quick questions about your water and your household, and we will ' +
          'point you at the system we would actually recommend.</div>' +
          '<div class="mwf-ff__head-m">' +
            '<span>' + I.tick + '5 questions</span>' +
            '<span>' + I.tick + 'About 30 seconds</span>' +
            '<span>' + I.tick + 'No email required</span>' +
          '</div>' +
        '</div>' +
      '</div>');

    if (state.step <= 4) {
      var rail = document.createElement('div');
      rail.className = 'mwf-ff__rail';
      for (var i = 0; i < STEPS.length; i++) {
        var n = i + 1;
        var cls = 'mwf-ff__step' + (state.step === n ? ' is-now' : (state.step > n ? ' is-done' : ''));
        rail.insertAdjacentHTML('beforeend',
          '<div class="' + cls + '"><span class="mwf-ff__step-n">Step ' + n +
          '</span><span class="mwf-ff__step-l">' + STEPS[i] + '</span></div>');
      }
      root.appendChild(rail);

      /* Four labels do not fit a phone; one bar carries the same information. */
      root.insertAdjacentHTML('beforeend',
        '<div class="mwf-ff__rail-sm">' +
          '<div class="mwf-ff__rail-sm-t">Step ' + state.step + ' of ' + STEPS.length + ' &middot; ' + STEPS[state.step - 1] + '</div>' +
          '<div class="mwf-ff__bar"><span style="width:' + (state.step / STEPS.length * 100) + '%"></span></div>' +
        '</div>');
    }

    var stage = document.createElement('div');
    stage.className = 'mwf-ff__stage';
    root.appendChild(stage);

    function go(patch) {
      for (var k in patch) { if (Object.prototype.hasOwnProperty.call(patch, k)) state[k] = patch[k]; }
      render(mount, state);
      root.scrollIntoView({ block: 'nearest' });
    }

    /* ------------------------------------------------------- result ----- */
    if (state.step >= 6 && state.source === 'unsure') {
      stage.insertAdjacentHTML('beforeend',
        '<div class="mwf-ff__res-main">' +
          '<span class="mwf-ff__badge is-low">' + I.warn + ' We need one more thing</span>' +
          '<div class="mwf-ff__res-h" role="heading" aria-level="3">Let\u2019s work out where your water comes from</div>' +
          '<div class="mwf-ff__why">Mains water and tank water need almost opposite treatment, so this is the ' +
          'one answer we cannot guess for you. It is usually quick to settle:</div>' +
          '<div class="mwf-ff__reasons" role="list">' +
            '<div class="mwf-ff__reason" role="listitem">' + I.tick + '<span>Do you get a water bill from a utility? That is town or city mains.</span></div>' +
            '<div class="mwf-ff__reason" role="listitem">' + I.tick + '<span>Is there a tank outside collecting off the roof, with a pump near it? That is rain water.</span></div>' +
            '<div class="mwf-ff__reason" role="listitem">' + I.tick + '<span>Is there a bore or pump drawing from the ground or a creek? That is bore water.</span></div>' +
            '<div class="mwf-ff__reason" role="listitem">' + I.tick + '<span>Renting or just moved in? The agent or owner will know, and a neighbour almost certainly does.</span></div>' +
          '</div>' +
        '</div>' +
        '<div class="mwf-ff__foot">' +
          '<button type="button" class="mwf-ff__btn mwf-ff__btn--ghost" data-restart>&larr; Start again</button>' +
          '<a class="mwf-ff__btn mwf-ff__btn--cta" href="' + SHOP + '/pages/contact-us">Ask us and we\u2019ll help &rarr;</a>' +
        '</div>');
      stage.querySelector('[data-restart]').addEventListener('click', function () {
        go({ step: 1, source: null, size: null, concerns: {}, pressure: null, drink: null, state: null });
      });
      track('filter_finder_source_unsure', {});
      mount.appendChild(root);
      return;
    }

    if (state.step >= 6) {
      var rule = resolve(state);
      if (!rule) { go({ step: 1 }); return; }
      var coll = COLLECTIONS[srcKey(state)];

      var shot = rule.pick.img
        ? '<img class="mwf-ff__shot" src="' + rule.pick.img + '" alt="" loading="lazy" width="260" height="190">'
        : '';

      var main =
        '<span class="mwf-ff__badge">' + I.tick + ' Your match</span>' +
        '<div class="mwf-ff__res-h" role="heading" aria-level="3">' + esc(rule.pick.n) + '</div>' +
        '<div class="mwf-ff__why">' + rule.why + '</div>' +
        '<div class="mwf-ff__reasons" role="list">' +
          rule.reasons.map(function (r) {
            return '<div class="mwf-ff__reason" role="listitem">' + I.tick + '<span>' + r + '</span></div>';
          }).join('') +
        '</div>';

      var side =
        '<div class="mwf-ff__pick">' +
          '<div class="mwf-ff__pick-hd">Recommended system</div>' +
          '<div class="mwf-ff__pick-bd">' +
            shot +
            '<div class="mwf-ff__pick-nm">' + esc(rule.pick.n) + '</div>' +
            '<a class="mwf-ff__btn mwf-ff__btn--cta" data-ff-go href="' + P(rule.pick.h) + '">View this system</a>' +
          '</div>' +
        '</div>';

      /* The test-first warning is reasoning, so it belongs in the left column
         with the rest of it - appended before the two columns are assembled. */
      if (state.source === 'bore') {
        main += '<div class="mwf-ff__flag">' + I.warn +
          '<div><div class="mwf-ff__flag-t">Get your water tested first</div>' +
          '<div class="mwf-ff__flag-d">Bore and creek water varies enormously between properties. A test tells you ' +
          'whether you are treating iron, hardness, bacteria or all three — and stops you buying the wrong system twice. ' +
          '<a class="mwf-ff__link" href="' + C('water-testing-equipments') + '">See water testing kits</a></div></div></div>';
      }

      var html = '<div class="mwf-ff__res">' +
        '<div class="mwf-ff__res-main">' + main + '</div>' +
        '<div class="mwf-ff__res-side">' + side + '</div>' +
      '</div>';

      html += '<div class="mwf-ff__alts">' + pickAlts(srcKey(state), rule.pick.h).map(function (a) {
        return '<div class="mwf-ff__alt">' +
               (a.p.img ? '<img class="mwf-ff__alt-shot" src="' + a.p.img + '" alt="" loading="lazy" width="52" height="52">' : '') +
               '<div><div class="mwf-ff__alt-k">' + a.k + '</div>' +
               '<div class="mwf-ff__alt-nm"><a class="mwf-ff__link" href="' + P(a.p.h) + '">' + esc(a.p.n) + '</a></div>' +
               '<div class="mwf-ff__alt-d">' + a.d + '</div></div></div>';
      }).join('') + '</div>';

      html += '<div class="mwf-ff__foot">' +
        '<button type="button" class="mwf-ff__btn mwf-ff__btn--ghost" data-ff-restart>← Start again</button>' +
        '<a class="mwf-ff__btn mwf-ff__btn--alt" href="' + C(coll.h) + '">' + coll.n + ' →</a>' +
        '</div>';

      stage.innerHTML = html;

      stage.querySelector('[data-ff-restart]').addEventListener('click', function () {
        go({ step: 1, source: null, size: null, concerns: {}, pressure: null, drink: null, state: null });
      });
      stage.querySelector('[data-ff-go]').addEventListener('click', function () {
        track('filter_finder_result_click', { product: rule.pick.h, source: state.source, au_state: state.state });
      });

      track('filter_finder_result', { product: rule.pick.h, source: state.source, size: state.size, au_state: state.state });
      mount.appendChild(root);
      return;
    }

    /* ----------------------------------------------------- questions ---- */
    var title, hint, list, key = null, chosen = null, cols = 3, multi = false;

    if (state.step === 1) {
      title = 'Where does your water come from?';
      hint  = 'This is the single biggest factor. Mains water and tank water need almost opposite treatment.';
      list  = SOURCES; key = 'source'; chosen = state.source;
    } else if (state.step === 2) {
      title = 'How many people live in the home?';
      hint  = 'This sets the housing size and how many stages you need to hold pressure across the house.';
      list  = SIZES; key = 'size'; chosen = state.size;
    } else if (state.step === 3) {
      title = 'What made you curious about your water?';
      hint  = 'Choose as many as apply, or tell us nothing in particular stands out. These change with your water source.';
      list  = CONCERNS[srcKey(state)]; multi = true; cols = 2;
    } else if (state.step === 5) {
      title = 'Last one — which state are you in?';
      hint  = 'This does not change your recommendation. It tells us who can install or service it near you.';
      list  = STATES; key = 'state'; chosen = state.state; cols = 2;
    } else if (srcKey(state) === 'city') {
      title = 'Do you want filtered drinking water at the kitchen tap too?';
      hint  = 'A whole house system treats every outlet. Some households add a dedicated drinking tap as well.';
      list  = DRINKING; key = 'drink'; chosen = state.drink; cols = 2;
    } else {
      title = 'How is water delivered to the house?';
      hint  = 'Gravity-fed systems need equipment rated for low pressure — it changes which ultraviolet unit will work.';
      list  = PRESSURE; key = 'pressure'; chosen = state.pressure; cols = 2;
    }

    stage.insertAdjacentHTML('beforeend',
      '<div class="mwf-ff__qhead">' +
        '<div class="mwf-ff__q" role="heading" aria-level="3">' + title + '</div>' +
        '<div class="mwf-ff__hint">' + hint + '</div>' +
      '</div>');

    var wrap = document.createElement('div');
    wrap.className = 'mwf-ff__opts mwf-ff__opts--' + cols;

    list.forEach(function (o) {
      var on = multi ? !!state.concerns[o.id] : chosen === o.id;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mwf-ff__opt';
      b.dataset.id = o.id;   /* matches the cartridge finder, and makes each answer addressable */
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.innerHTML =
        (multi ? '<span class="mwf-ff__box">' + I.check + '</span>'
               : '<span class="mwf-ff__ico">' + (o.icon || I.drip) + '</span>') +
        '<span class="mwf-ff__txt"><span class="mwf-ff__t">' + o.t +
        '</span><span class="mwf-ff__d">' + o.d + '</span></span>';

      b.addEventListener('click', function () {
        if (multi) {
          if (state.concerns[o.id]) { delete state.concerns[o.id]; } else { state.concerns[o.id] = true; }
          render(mount, state);
        } else {
          var patch = {};
          patch[key] = o.id;
          /* Not knowing the source ends the funnel here. Mains and tank need
             almost opposite treatment, so there is no product we could name
             without guessing - and the next three questions would only be
             collecting answers we could not act on. */
          patch.step = (key === 'source' && o.id === 'unsure') ? 6 : state.step + 1;
          if (key === 'source') { patch.concerns = {}; }
          track('filter_finder_step', { step: state.step, answer: o.id });
          go(patch);
        }
      });
      wrap.appendChild(b);
    });
    stage.appendChild(wrap);

    /* footer */
    var foot = document.createElement('div');
    foot.className = 'mwf-ff__foot';

    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'mwf-ff__btn mwf-ff__btn--ghost';
    back.textContent = '← Back';
    back.style.visibility = state.step === 1 ? 'hidden' : 'visible';
    back.addEventListener('click', function () { go({ step: state.step - 1 }); });
    foot.appendChild(back);

    var right = document.createElement('div');
    right.className = 'mwf-ff__foot-right';

    if (multi) {
      var picked = Object.keys(state.concerns).length;
      var count = document.createElement('span');
      count.className = 'mwf-ff__count';
      count.textContent = picked === 0 ? 'Pick at least one' : picked + ' selected';
      right.appendChild(count);

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'mwf-ff__btn mwf-ff__btn--cta';
      next.textContent = 'Continue';
      next.disabled = picked === 0;
      next.addEventListener('click', function () {
        track('filter_finder_step', { step: 3, answer: Object.keys(state.concerns).join(',') });
        go({ step: 4 });
      });
      right.appendChild(next);
    } else {
      var c2 = document.createElement('span');
      c2.className = 'mwf-ff__count';
      c2.textContent = 'Step ' + state.step + ' of ' + STEPS.length;
      right.appendChild(c2);
    }

    foot.appendChild(right);
    stage.appendChild(foot);
    mount.appendChild(root);
  }

  function boot() {
    var mounts = document.querySelectorAll('#mwf-filter-finder, [data-mwf-filter-finder]');
    for (var i = 0; i < mounts.length; i++) {
      if (mounts[i].getAttribute('data-ff-ready') === '1') continue;
      mounts[i].setAttribute('data-ff-ready', '1');
      render(mounts[i], { step: 1, source: null, size: null, concerns: {}, pressure: null, drink: null, state: null });
      track('filter_finder_view', {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
